import { render, staticRenderFns } from "./Tariffe.vue?vue&type=template&id=350ceb9b&"
import script from "./Tariffe.vue?vue&type=script&lang=ts&"
export * from "./Tariffe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports